import { getStorage } from "@/libs/storage"

const appId = getStorage("appId")
const GLOBALCOLOR = appId === "wxfcb34416b1538017" ? "#0bc94e" : "#00a5ff"
const GLOBALCOLOR1 = appId === "wxfcb34416b1538017" ? "#aaffc8" : "#bcecff"
export default {
  GLOBALCOLOR,
  GLOBALCOLOR1,
}
